import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { ProTipsServiceService } from './service/pro-tips-service.service';
import { Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';


@Component({
  selector: 'app-nemt-pro-tips',
  templateUrl: './nemt-pro-tips.component.html',
  styleUrls: ['./nemt-pro-tips.component.css']
})
export class NemtProTipsComponent implements OnInit, OnDestroy {
  proTips = [];
  images = [];

  constructor(private proTipsService: ProTipsServiceService) { }

  ngOnInit() {
    this.getNemtProTips();
  }

  getNemtProTips() {
    this.proTipsService.getProTips()
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.proTips = data;
        }
      },
    );
  }


  isValidHttpUrl(imgUrl) {
    

    return imgUrl ? imgUrl : 'assets/images/placeholders/no_image.png'
  }

  ngOnDestroy(): void {
  }
}
